const PageNotFound = () => {
  return (
    <div>
      <img src="https://www.argildx.com/wp-content/uploads/2017/06/Is-a-Misconfigured-%E2%80%9CPage-Not-Found%E2%80%9D-Jeopardizing-Your-Website.jpg" />
    </div>
  )
}

export default PageNotFound
